import React, { Component } from 'react';
class RichMenuDescription extends Component {

    constructor() {
        super();
        this.state = {
            url: {}
        };
    }
    render() {
        let layout = this.props.layout.template;
        let nrow = layout.length;
        let rows = [];
        let itemNo = 0;
        for (var r = 0; r < nrow; r++) {
            let cols = [];
            for (var c = 0; c < layout[r]; c++) {
                let itemName = (r + 1) + '-' + (c + 1);

                cols.push(<div key={itemName} className="column">
                    <div className="richmenu-description-block">
                        <div className="label is-small">{itemName}</div>
                        <div className="field is-horizontal">
                            <div class="field-label is-small">
                                <label className="label">Action:</label>
                            </div>
                            <div class="field-body">
                                <div className="select is-small">
                                    <select
                                        name={`[${itemNo}].action.type`}
                                        onChange={this.props.onChange}
                                        value={this.props.description[itemNo] && this.props.description[itemNo].action.type}>
                                        <option value="message">Message</option>
                                        <option value="uri">Uri</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        {this.props.description[itemNo] && this.props.description[itemNo].action.type === 'uri' && <div className="field">
                            <div className="control">
                                <input className="input is-small"
                                    name={`[${itemNo}].action.uri`}
                                    type="text"
                                    placeholder=""
                                    onChange={this.props.onChange}
                                    value={this.props.description[itemNo] && this.props.description[itemNo].action.uri} />
                            </div>
                        </div>}
                        {this.props.description[itemNo] && this.props.description[itemNo].action.type === 'message' && <div className="field">
                            <div className="control">
                                <input className="input is-small"
                                    name={`[${itemNo}].action.text`}
                                    type="text"
                                    placeholder=""
                                    onChange={this.props.onChange}
                                    value={this.props.description[itemNo] && this.props.description[itemNo].action.text} />
                            </div>
                        </div>}
                    </div>
                </div>)

                itemNo++;
            }

            rows.push(<div key={r} className={`columns is-mobile is-variable is-1 r${nrow}`}>{cols}</div>)
        }
        return (
            <div className="rich-menu-description" onClick={this.props.onClick}>{rows}</div>
        )
    }
}
export default RichMenuDescription